import axiosClient from "./axiosClient";

const endpoint = "/commerce/order-pricing/rules";

export const orderPricingApi = {
  async list(commerceOrderPolicyProfileId = null) {
    const response = await axiosClient.get(endpoint, {
      __silentGenericToast: true,
      params: commerceOrderPolicyProfileId
        ? { commerceOrderPolicyProfileId }
        : undefined,
    });
    return response.data;
  },
  async create(rule, commerceOrderPolicyProfileId = null) {
    const response = await axiosClient.post(endpoint, {
      ...rule,
      ...(commerceOrderPolicyProfileId ? { commerceOrderPolicyProfileId } : {}),
    }, {
      __silentGenericToast: true,
    });
    return response.data;
  },
  async update(code, rule, commerceOrderPolicyProfileId = null) {
    const response = await axiosClient.put(
      `${endpoint}/${encodeURIComponent(code)}`,
      {
        ...rule,
        ...(commerceOrderPolicyProfileId ? { commerceOrderPolicyProfileId } : {}),
      },
      { __silentGenericToast: true },
    );
    return response.data;
  },
};
